export default function showMore() {
  const button = document.querySelector('[show-more]');

  if(button) {
    let list = document.querySelector('[data-list]');
    let items = [...document.querySelectorAll('[list-item]')];
    let itemsLength = items.length;
    let itemsToShow = 2;

    button.addEventListener('click', ()=>{
      let array = Array.from(document.querySelector('[data-list]').children);
      itemsToShow += 2;

      let visItems = array.slice(0, itemsToShow);
      console.log(visItems.length);

      visItems.forEach(el => el.classList.add('is-visible'))

      if(visItems.length >= itemsLength) {
        button.style.display = "none"
      }
    });

    if(itemsToShow >= itemsLength) {
      button.style.display = "none"
    } else {
      button.style.display = "block"
    }
  }
}
